import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const CREATE_DRIVER_PATH = '/api/v5/drivers';

export type CreatedDriver = { id: number; name: string };

export const useMutationDriver = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (name: string): Promise<CreatedDriver> => {
      const response = await axios.post<CreatedDriver>(CREATE_DRIVER_PATH, { driver: { name } });
      return response.data;
    },
    { onSuccess: () => { void queryClient.invalidateQueries(['useDriversQuery']); } },
  );
};
